export const typeOfSupport = [
    {
        value: '1',
        label: 'Caring for parent/s',
        option: 'A',
        instruction: '',
    },
    {
        value: '2',
        label: 'Caring for extended family',
        option: 'B',
        instruction: '',
    },
    {
        value: '3',
        label: 'Caring for sibling/s',
        option: 'C',
        instruction: '',
    },
    {
        value: '4',
        label: 'Caring for children (18 and over)',
        option: 'D',
        instruction: '',
    },
    {
        value: '5',
        label: 'Caring for grandparent/s',
        option: 'E',
        instruction: '',
    },
    {
        value: '6',
        label: 'Caring for neighbours/friends',
        option: 'F',
        instruction: '',
    },
    {
        value: '7',
        label: 'Caring for children (under 18)',
        option: 'G',
        instruction: '',
    },
    {
        value: '8',
        label: 'Caring for partner',
        option: 'H',
        instruction: '',
    },
    {
        value: '9',
        label: 'Caring for more than one person',
        option: 'I',
        instruction: '',
    },
    {
        value: '0',
        label: 'Other',
        option: 'J',
        instruction: '',
    },
];
